export default __webpack_public_path__ + "static/media/auto.de5e638e.jpg";